import { Component, OnInit } from "@angular/core";
import { MainService } from "../../main.service";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { MatSnackBar } from "@angular/material";
import { loadStripe, Stripe, StripeCardElement } from "@stripe/stripe-js";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-payment-cards",
  templateUrl: "./payment-cards.component.html",
  styleUrls: ["./payment-cards.component.scss"],
})
export class PaymentCardsComponent implements OnInit {
  card!: StripeCardElement;
  isAutoPaymentEnabled: boolean = false;

  stripe!: Stripe;
  savedCards = [];
  cardholderName: string = "";
  nameTouched: boolean = false;
  bookingDetailId: any;
  defaultCardSet: boolean = false;
  pendingDetails: any;
  selectedCardId: string;
  isModalOpen = false;
  isLoading: boolean = false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };

  constructor(
    private mainservice: MainService,
    private modalService: NgbModal,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.queryParams.subscribe((params) => {
      this.bookingDetailId = params["bookingId"];
    });
  }

  async ngOnInit() {
    this.getUserDetails();
    this.getSavedCards();
    this.stripe = await loadStripe(
      "pk_test_51PnI7CLSMEXLkEQvJRRPg3K1Oo8IVSaM6PYtH6dITmVt3MDa64OY6LmAxQVmrfuZVC3jYobeFRdlVLadvcDketex00FV1ZgMPS"
    );
  }







  openPaymentModal(content: any) {
    this.modalService.dismissAll();

    this.isModalOpen = true;

    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };

    this.modalService.open(content).result.finally(() => {
      this.isModalOpen = false;
    });

    setTimeout(() => {
      if (!this.card) {
        const elements = this.stripe.elements();
        this.card = elements.create("card");
        this.card.mount("#card-element");
      }
    });
  }

  confirmCardSelection() {
    if (!this.selectedCardId) {
      alert("Please select a card");
      return;
    }

    this.payPaymentWithCard(this.selectedCardId);
  }

  payPaymentWithCard(cardId: string) {
    Swal.fire({
      title: "Confirm Payment",
      text: "Are you sure you want to proceed with the payment using the selected card?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      const bookingDetailId = this.bookingDetailId;
      const query = `bookingDetailId=${bookingDetailId}&cardId=${cardId}`;

      this.mainservice.createStripe(query).subscribe({
        next: (res) => {
          if (res.message === "Success") {
            this._snackBar.open(res?.data?.message, "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
            this.router.navigate(["/main/home"]);
          } else {
            this._snackBar.open("Payment failed. Please try again.", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["error"],
            });
          }
        },
        error: (err) => {
          console.error(err);
          this._snackBar.open("Error processing payment.", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["error"],
          });
        },
      });
    });
  }

  // getSavedCards() {
  //   this.isLoading = true;
  //   this.mainservice.getSavedCards().subscribe((res) => {
  //     if (res.message === "Success") {
  //       this.savedCards = res?.data?.cardList;
  //       console.log(res, "Saved Cards Response");
  //     }
  //   });
  // }

  getSavedCards() {
    this.isLoading = true;
    this.mainservice.getSavedCards().subscribe({
      next: (res) => {
        if (res.message === "Success") {
          this.savedCards = res?.data?.cardList;

          // Auto-select the default card
          const defaultCard = this.savedCards.find(card => card.isDefault);
          if (defaultCard) {
            this.selectedCardId = defaultCard.cardId;
            this.defaultCardSet = true;
          }
        }
        this.isLoading = false;
      },
      error: (err) => {
        console.error(err);
        this.isLoading = false;
      },
    });
  }





  // async submitPayment(modal: any) {
  //   this.nameTouched = true;
  //   if (!this.cardholderName) {
  //     return;
  //   }
  //   const { token, error } = await this.stripe.createToken(this.card);
  //   if (error) {
  //     console.error(error);
  //   } else {
  //     const req = {
  //       cardToken: token.id,
  //     };

  //     if (req) {
  //       modal.close();
  //       this.mainservice.addCNewCards(req).subscribe((res) => {
  //         if (res["message"] == "Success") {
  //           this._snackBar.open("Card added successfully!", "", {
  //             duration: 3000,
  //             horizontalPosition: "right",
  //             verticalPosition: "top",
  //             panelClass: ["success"],
  //           });
  //           this.getSavedCards();
  //           this.modalService.dismissAll();
  //         } else {
  //           this._snackBar.open("Failed to add card.", "", {
  //             duration: 3000,
  //             horizontalPosition: "right",
  //             verticalPosition: "top",
  //             panelClass: ["error"],
  //           });
  //         }
  //       });
  //     } else {
  //       console.error("Request body is empty or invalid.");
  //     }
  //   }
  // }


  async submitPayment(modal: any) {
    this.nameTouched = true;
    if (!this.cardholderName) return;

    const { token, error } = await this.stripe.createToken(this.card);

    if (error) {
      console.error(error);
    } else {
      const req = { cardToken: token.id };

      if (req) {
        modal.close();
        this.isLoading = true;
        this.mainservice.addCNewCards(req).subscribe({
          next: (res) => {
            this.isLoading = false;
            if (res.message === "Success") {
              this._snackBar.open("Card added successfully!", "", {
                duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"],
              });
              this.getSavedCards();
              this.getUserDetails();
              this.modalService.dismissAll();
            } else {
              this._snackBar.open("Failed to add card.", "", {
                duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["error"],
              });
            }
          },
          error: (err) => {
            this.isLoading = false;
            console.error(err);
            this._snackBar.open("Error adding card.", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["error"],
            });
          },
        });
      }
    }
  }



  getUserDetails() {
    this.isLoading = true;
    this.mainservice.getUserDetails().subscribe(
      (res) => {
        this.isLoading = false;

        if (res["message"] == "Success") {
          let userData = res.data.response;
           setTimeout(() => {
            localStorage.setItem(
              "userData",
              JSON.stringify(userData)
            );
          }, 1000);
          this.isAutoPaymentEnabled = userData?.isAutoPaymentEnabled

        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }




  toggleAutoPay() {
    this.isAutoPaymentEnabled = !this.isAutoPaymentEnabled
    const req = {
      isAutoPaymentEnabled: this?.isAutoPaymentEnabled,
    };
    this.isLoading = true;
    this.mainservice.updateUser(req).subscribe(
      (res) => {
        if (res["message"] === "Success") {
          setTimeout(() => {
            localStorage.setItem(
              "userData",
              JSON.stringify(res["data"]["response"])
            );
          }, 1000);
          this._snackBar.open("Auto Payment updated successfully!", "success", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          this.isLoading = false;
        }
      },
      (err) => {
        this._snackBar.open("Failed to update Auto Payment", "error", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["error"],
        });
      }
    );
  }




  // async toggleAutoPay(card: any) {
  //   console;
  //   const action = card.isDefault ? "disable" : "enable";

  //   const req = {
  //     cardId: card?.cardId,
  //   };
  //   if (req) {
  //     this.mainservice.updateAutoPayStatus(req).subscribe({
  //       next: (res) => {
  //         if (res.message === "Success") {
  //           this._snackBar.open(
  //             `AutoPay ${
  //               action === "enable" ? "enabled" : "disabled"
  //             } for card.`,
  //             "",
  //             {
  //               duration: 3000,
  //               horizontalPosition: "right",
  //               verticalPosition: "top",
  //               panelClass: ["success"],
  //             }
  //           );
  //           this.getSavedCards();
  //         } else {
  //           this._snackBar.open("Failed to update AutoPay.", "", {
  //             duration: 3000,
  //             horizontalPosition: "right",
  //             verticalPosition: "top",
  //             panelClass: ["error"],
  //           });
  //         }
  //       },
  //       error: (err) => {
  //         console.error(err);
  //         this._snackBar.open("Error updating AutoPay.", "", {
  //           duration: 3000,
  //           horizontalPosition: "right",
  //           verticalPosition: "top",
  //           panelClass: ["error"],
  //         });
  //       },
  //     });
  //   }
  // }

  updateAutoPay(cardId: string, action: "enable" | "disable") {
    return this.mainservice.updateAutoPayStatus(cardId).subscribe({
      next: (res) => {
        if (res.message === "Success") {
          this._snackBar.open(
            `AutoPay ${action === "enable" ? "enabled" : "disabled"} for card.`,
            "",
            {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            }
          );
          this.getSavedCards();
        } else {
          this._snackBar.open("Failed to update AutoPay.", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["error"],
          });
        }
      },
      error: (err) => {
        console.error(err);
        this._snackBar.open("Error updating AutoPay.", "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["error"],
        });
      },
    });
  }

  onDeleteCard(card: any) {
    Swal.fire({
      title: "Delete Card",
      text: "Are you sure you want to delete this card?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.mainservice.deleteCard(card?.cardId).subscribe({
          next: (res) => {
            if (res.message === "Success") {
              this._snackBar.open("Card deleted successfully.", "", {
                duration: 3000,
                horizontalPosition: "right",
                verticalPosition: "top",
                panelClass: ["success"],
              });
              this.getSavedCards();
            } else {
              Swal.fire({
                icon: "error",
                title: "Failed!",
                text: "Failed to delete card.",
              });
            }
          },
          error: (err) => {
            console.error(err);
            this._snackBar.open("Error deleting card.", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["error"],
            });
          },
        });
      }
    });
  }

  onCardSelected(card: any) {
    this.selectedCardId = card?.cardId;
    this.defaultCardSet = false;
    // Call the same toggle function you already have
    this.mainservice.updateAutoPayStatus({ cardId: card?.cardId }).subscribe({
      next: (res) => {
        if (res.message === "Success") {
          this._snackBar.open("Card marked as default!", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          this.defaultCardSet = true;
          this.getSavedCards();
        } else {
          this._snackBar.open("Failed to update default card.", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["error"],
          });
        }
      },
      error: (err) => {
        console.error(err);
        this._snackBar.open("Error updating default card.", "", {
          duration: 3000,
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: ["error"],
        });
      },
    });
  }
}
